const siteHeader = document.querySelector(".site-header");
const scrollPixel = document.querySelector(".scroll-pixel");

export default {
  init: () => {
    if (siteHeader && scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }
  },
};
